import { storyblokEditable, renderRichText } from "@storyblok/react"

export default function ValueItem({ blok }: any) {
  return (
    <div {...storyblokEditable(blok)} className="flex flex-col">
      <div
        className="font-['BeausiteClassic'] font-bold text-lg md:text-xl text-gray-900"
        dangerouslySetInnerHTML={{
          __html: renderRichText(blok.title || { content: [] }) || "",
        }}
      />
      <span className="mt-2 h-[3px] w-10 rounded-full bg-gradient-to-r from-[#FFD700] to-[#fbf7e1]" />
      <div
        className="mt-4 font-['BeausiteClassic'] text-sm md:text-base text-gray-700 leading-relaxed"
        dangerouslySetInnerHTML={{
          __html: renderRichText(blok.description || { content: [] }) || "",
        }}
      />
    </div>
  )
}
